/* import __COLOCATED_TEMPLATE__ from './tab.hbs'; */
/**

## Tab

The Tab component is a singular component to be used within the [navigation](../../navigation.html)
of a [Selector Control component](../../../selector-control.html)

```example
@title Inactive

@hbs
{{selector-control/navigation/item/tab label="Inactive Tab"}}
```

```example
@title Active

@hbs
{{selector-control/navigation/item/tab label="Active Tab" isActive=true}}
```

```example
@title Passing a block
@description You can pass a block to use as the text of the tab instead of passing a string through the label param

@hbs
{{#selector-control/navigation/item/tab isActive=true}}
  Tab with <em>Emphasis</em>
{{/selector-control/navigation/item/tab}}
```

@param {String} label - Text for the tab. Can also pass a block instead
@param {Boolean} isActive=false - Determines whether or not the tab is in an active state
*/

import Component from '@ember/component';
import { computed } from '@ember/object';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'a',
  classNames: ['tab-set__tab'],
  classNameBindings: ['isActive:tab-set__tab--is-active'],
  attributeBindings: ['data-test-selector-control-tab', 'role', 'aria-controls', 'aria-selected'],
  'data-test-selector-control-tab': computed('isActive', function () {
    if (this.get('isActive')) {
      return 'active';
    } else {
      return 'inactive';
    }
  }),
  isActive: false,
  role: 'tab',
  'aria-controls': 'selector-control-content',
  'aria-selected': computed('isActive', function () {
    return this.get('isActive') ? 'true' : 'false';
  }),
  click() {
    if (this.onSelect) {
      this.onSelect();
    }
  }
});